export class DosageRemarkModel{
  /** 早 Morning */
  M:number = 0;
  /** 午 Afternoon*/
  A:number = 0;
  /** 晚 Evening */
  E:number = 0;
  /** 睡 Night */
  N:number = 0;
  /**
   *
   */
  constructor(json:string) {
    var jObject = JSON.parse(json||'{}');
    this.M = Number(jObject?.M)||0;
    this.A = Number(jObject?.A)||0;
    this.E = Number(jObject?.E)||0;
    this.N = Number(jObject?.N)||0;
  }
  toString(){
    var s = [];
    if(this.M){ s.push(`早${this.M}`) }
    if(this.A){ s.push(`午${this.A}`) }
    if(this.E){ s.push(`晚${this.E}`) }
    if(this.N){ s.push(`睡${this.N}`) }
    return s.join(' ');
  }
  getDailyDose(){
    return Number(this.M) + Number(this.A) + Number(this.E) + Number(this.N);
  }
  getFirstDose(){
    // 依序取得第一個非0
    return Number(this.M)|| Number(this.A) || Number(this.E) || Number(this.N);
  }
  toJson(){
    // 雙向綁定後可能會變字串 強制轉回數字
    this.M = Number(this.M)||0;
    this.A = Number(this.A)||0;
    this.E = Number(this.E)||0;
    this.N = Number(this.N)||0;
    return JSON.stringify(this);
  }
};